import { api } from './api';

export const reportService = {
  /**
   * Fetch shipment details for report
   */
  async getShipmentReport(
    userId: string | number,
    startDate?: string,
    endDate?: string
  ) {
    const url = `/shipment/download/${userId}/csv`;
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const { data } = await api.get(`${url}?${params.toString()}`);
    return data;
  },
};
